import gqlOrig from 'graphql-tag';

const cache = new Map();

function trim(str) {
  return str.replace(/^([ \t\r]*\n)+/, '').trimRight();
}

// Improved gql tag that removes duplicate fragments
export function gql(
  strings,
  ...docs
) {
  const parts = [trim(strings[0])];

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < docs.length; i++) {
    const doc = docs[i];

    if (!doc) {
      throw Error(`Document not found: ${strings}`);
    }

    const body = doc.loc?.source.body;
    if (!body) {
      throw Error(`Document must have a source: ${JSON.stringify(doc)}`);
    }

    const cacheParts = cache.get(body);
    if (!cacheParts) {
      throw Error(
        `Are you sure you don't mix gql-dedup usage with the plain graphql-tag?
         (If you use tsc compiler, also make sure to check if the compiler output file is not stale;
          tsc has some bugs, especially during incremental builds.) We can't find the following document
          node in gql-dedup registry: [${body}]`,
      );
    }

    parts.push(...cacheParts);
    parts.push(trim(strings[i + 1]));
  }

  const uniqueParts = [...new Set(parts).keys()];
  const uniqueBody = uniqueParts.filter((part) => part !== '').join('\n');
  cache.set(uniqueBody, uniqueParts);

  return gqlOrig(uniqueBody);
}
